import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Edit() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const focusInputRef = useRef(null);
  const location = useLocation();
  const { id } = location.state || {};
  const currentPath = location?.pathname || '';

  const [loaded, setLoaded] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    programObjectiveIds: [],
  });
  const [objectives, setObjectives] = useState([]);

  // Role check and focus
  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') navigate('/');

    if (focusInputRef.current) focusInputRef.current.focus();
  }, [navigate]);

  // Fetch objectives
  useEffect(() => {
    axios
      .get(`${apiUrl}/api/program-objective/`, {
        headers: { Authorization: token },
      })
      .then((res) => {
        const options = res.data.programObjectives.map((item) => ({
          value: item.id,
          label: item.objectiveName,
        }));
        setObjectives(options);
      })
      .catch((err) => {
        toast.error('Failed to fetch objectives');
        console.error(err);
      });
  }, [apiUrl, token]);

  // Fetch program by ID and prefill form
  useEffect(() => {
    if (!id) return;

    axios
      .get(`${apiUrl}/api/program/${id}`, {
        headers: { Authorization: token },
      })
      .then((res) => {
        const { name, programObjectives } = res.data;

        setFormData({
          name: name,
          programObjectiveIds: programObjectives.map((obj) => ({
            value: obj.id,
            label: obj.objectiveName,
          })),
        });
      })
      .catch((err) => {
        toast.error('Failed to fetch program details');
        console.error(err);
      });
  }, [id, apiUrl, token]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);

    const payload = {
      name: formData.name,
      objectiveIds: formData.programObjectiveIds.map((obj) => obj.value),
    };

    axios
      .put(`${apiUrl}/api/program/${id}`, payload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        toast.success('Program updated successfully');
        setLoaded(false);
        setFormData({ name: '', programObjectiveIds: [] });
        focusInputRef.current?.focus();

        if (currentPath === '/ProgramEdit') {
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/ProgramEdit') {
              navigate('/ProgramList');
            }
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Error updating data');
        if (err.response?.status === 401) navigate('/');
        setLoaded(false);
      });
  };

  return (
    <AdminLayout ac15="active" dr="true">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/ProgramList">View Program</Link>
              </li>
              <li className="breadcrumb-item active">Edit New Program</li>
            </ol>
          </nav>
        </div>

        <section className="section col-lg-12">
          <div className="row">
            <div className="card">
              <div className="card-body mt-5 mx-3">
                <form onSubmit={handleSubmit}>
                  <div className="container">
                    <div className="row row-cols-1">
                      <div className="col-6">
                        <div className="form-floating mb-2">
                          <input
                            ref={focusInputRef}
                            className="form-control"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) =>
                              setFormData({ ...formData, name: e.target.value })
                            }
                            placeholder="Enter program name"
                            required
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Program Name <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-floating mb-2">
                          <Select
                            isMulti
                            name="programObjectiveIds"
                            placeholder="Select Program Objectives"
                            options={objectives}
                            value={formData.programObjectiveIds}
                            onChange={(selected) =>
                              setFormData({
                                ...formData,
                                programObjectiveIds: selected,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mx-1 bd-highlight">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i> Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-4 mx-1"
                          disabled={loaded}
                        >
                          {loaded ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{' '}
                              Wait...
                            </>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <ToastContainer position="top-center" />
              </div>
            </div>
          </div>
        </section>
      </main>
    </AdminLayout>
  );
}
